import { render, staticRenderFns } from "./DraftListEditB1.vue?vue&type=template&id=6011ffb4"
import script from "./DraftListEditB1.vue?vue&type=script&lang=js"
export * from "./DraftListEditB1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports